import React, { useState } from "react";

import { useParams } from 'react-router-dom';

import RequestService from "../../services/request.service";


import { Row, Col, Badge, Button, Form } from 'react-bootstrap';

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'


import { SERVER_ } from  '../../config';


import Dialog from '../../services/Dialogs'


import ModalClienteUsuarios from './ModalClienteUsuarios'



import ModalAgregarBoutique from './ModalAgregarBoutique'
import ModalEditarBoutique from './ModalEditarBoutique'



import ModalConfiguracionHorarios from './ModalConfiguracionHorarios'



import ModalNuevoContratoCliente from './ModalNuevoContratoCliente'


import ModalEquiposCriticosBoutique from './ModalEquiposCriticosBoutique'

import ModalContratoSeleccionarBoutique from './ModalContratoSeleccionarBoutique'
import ModalContratosCliente from './ModalContratosCliente'



import ModalTareasLimpiezaBoutique from './ModalTareasLimpiezaBoutique'

import ModalEditarDatosCliente from './ModalEditarDatosCliente'


import ModalTareasConservacionBoutique from './ModalTareasConservacionBoutique'


import ModalClienteResponsableMantenimiento from './ModalClienteResponsableMantenimiento'
import ModalClienteResponsableLimpieza from './ModalClienteResponsableLimpieza'


import ModalBoutiquesPendientes from './ModalBoutiquesPendientes'


import ModalBoutiquesUsuariosAcceso from './ModalBoutiquesUsuariosAcceso'



import { obtenerDiasRestantes, fechaPaso } from '../../services/funcionesPublicas'



import ModalAreasAtencionBoutique from './ModalAreasAtencionBoutique'






const Cliente = () =>{


  const dialog = new Dialog();



  const googleMapsApiKey = "AIzaSyAdoirFPgAEVFg4BNcf33PSaS0InB_ZGq0"

  let { uuid_cliente } = useParams();

  const [ cliente, setRegistro ] = useState<any>({
    idestado : {},
    idmunicipio : {},
    boutiques : [],
    contratos : []
  })

  const cargar = async () =>{
    try{
        let res = await RequestService.getEndPoint(`cliente/detalles/${ver_boutiques_sin_servicio}/${uuid_cliente}`)
        setRegistro(res.data)

    }
    catch(e){
      toast.error('Problemas cargando')
      toast.error(JSON.stringify(e))
    }
  }

  const cargarBoutiques = async (cargarBoutiques:boolean) =>{
    try{
        let res = await RequestService.getEndPoint(`cliente/detalles/${cargarBoutiques}/${uuid_cliente}`)
        setRegistro(res.data)

    }
    catch(e){
      toast.error('Problemas cargando')
      toast.error(JSON.stringify(e))
    }
  }

  React.useEffect(() => {
    cargar()
  }, []);



  const [ show_ModalAgregarBoutique, setModalAgregarBoutique ] = useState<boolean>(false)
  const handleShow_ModalAgregarBoutique = () => {
    setModalAgregarBoutique(true)
  }
  const handleClose_ModalAgregarBoutique = () => {
    cargar()
    setModalAgregarBoutique(false)
  }


  const [ boutique_seleccionada, setBoutiqueSeleccionada ] = useState<any>({})

const [ envio_server, setSeEnvio ] = useState<boolean>(false)


  const [ show_ModalEditarBoutique, setModalEditarBoutique ] = useState<boolean>(false)
  const handleShow_ModalEditarBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalEditarBoutique(true)
  }
  const handleClose_ModalEditarBoutique = () => {
    cargar()
    setModalEditarBoutique(false)
  }





  const [ show_ModalClienteUsuarios, setModalClienteUsuarios ] = useState<boolean>(false)
  const handleShow_ModalClienteUsuarios = () => {
    setModalClienteUsuarios(true)
  }
  const handleClose_ModalClienteUsuarios = () => {
    cargar()
    setModalClienteUsuarios(false)
  }


  const [ show_ModalConfiguracionHorarios, setModalConfiguracionHorarios ] = useState<boolean>(false)
  const handleShow_ModalConfiguracionHorarios = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalConfiguracionHorarios(true)
  }
  const handleClose_ModalConfiguracionHorarios = () => {
    cargar()
    setModalConfiguracionHorarios(false)
  }



  const [ show_ModalNuevoContratoCliente, setModalNuevoContratoCliente ] = useState<boolean>(false)
  const handleShow_ModalNuevoContratoCliente = () => {
    setModalNuevoContratoCliente(true)
  }
  const handleClose_ModalNuevoContratoCliente = () => {
    cargar()
    setModalNuevoContratoCliente(false)
  }



  const [ show_ModalEquiposCriticosBoutique, setModalEquiposCriticosBoutique ] = useState<boolean>(false)
  const handleShow_ModalEquiposCriticosBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalEquiposCriticosBoutique(true)
  }
  const handleClose_ModalEquiposCriticosBoutique = () => {
    cargar()
    setModalEquiposCriticosBoutique(false)
  }



  const [ show_ModalContratoSeleccionarBoutique, setModalContratoSeleccionarBoutique ] = useState<boolean>(false)
  const handleShow_ModalContratoSeleccionarBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalContratoSeleccionarBoutique(true)
  }
  const handleClose_ModalContratoSeleccionarBoutique = () => {
    cargar()
    setModalContratoSeleccionarBoutique(false)
  }


  const [ show_ModalContratosCliente, setModalContratosCliente ] = useState<boolean>(false)
  const handleShow_ModalContratosCliente = () => {
    setModalContratosCliente(true)
  }
  const handleClose_ModalContratosCliente = () => {
    cargar()
    setModalContratosCliente(false)
  }



  const [ show_ModalTareasLimpiezaBoutique, setModalTareasLimpiezaBoutique ] = useState<boolean>(false)
  const handleShow_ModalTareasLimpiezaBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalTareasLimpiezaBoutique(true)
  }
  const handleClose_ModalTareasLimpiezaBoutique = () => {
    cargar()
    setModalTareasLimpiezaBoutique(false)
  }






const eliminarContratoBoutique = async (event:any,boutique:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.delete( `boutique/contrato/${boutique.uuid}`)

        if(res_){
          toast.warning('Se elimino el response')
          setTimeout(()=>{
            cargar()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}



  const [ show_ModalEditarDatosCliente, setModalEditarDatosCliente ] = useState<boolean>(false)
  const handleShow_ModalEditarDatosCliente = () => {
    setModalEditarDatosCliente(true)
  }
  const handleClose_ModalEditarDatosCliente = () => {
            cargar()
    setModalEditarDatosCliente(false)
  }



  const [ show_ModalTareasConservacionBoutique, setModalTareasConservacionBoutique ] = useState<boolean>(false)
  const handleShow_ModalTareasConservacionBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalTareasConservacionBoutique(true)
  }
  const handleClose_ModalTareasConservacionBoutique = () => {
            cargar()
    setModalTareasConservacionBoutique(false)
  }





  const [ show_ModalClienteResponsableMantenimiento, setModalClienteResponsableMantenimiento ] = useState<boolean>(false)
  const handleShow_ModalClienteResponsableMantenimiento = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalClienteResponsableMantenimiento(true)
  }
  const handleClose_ModalClienteResponsableMantenimiento = () => {
            cargar()
    setModalClienteResponsableMantenimiento(false)
  }




  const [ show_ModalClienteResponsableLimpieza, setModalClienteResponsableLimpieza ] = useState<boolean>(false)
  const handleShow_ModalClienteResponsableLimpieza = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalClienteResponsableLimpieza(true)
  }
  const handleClose_ModalClienteResponsableLimpieza = () => {
            cargar()
    setModalClienteResponsableLimpieza(false)
  }







  const [ show_ModalBoutiquesUsuariosAcceso, setModalBoutiquesUsuariosAcceso ] = useState<boolean>(false)
  const handleShow_ModalBoutiquesUsuariosAcceso = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalBoutiquesUsuariosAcceso(true)
  }
  const handleClose_ModalBoutiquesUsuariosAcceso = () => {
    setModalBoutiquesUsuariosAcceso(false)
  }



  const [ boutiques_activas, setBoutiquesActivas ] = useState<any>({
    contrato_activo : true,
    contrato_finalizado : false,
    sin_contrato : false
  })

 const filasActivas = () =>{

 }

 // const sePrendeEstaBoutique = (boutique:any) =>{

 //    let se_muestra = false
 //    if(boutiques_activas.contrato_activo && (boutique.idcontrato !== null && !fechaPaso(new Date(),new Date(boutique.idcontrato.fecha_inicio),new Date(boutique.idcontrato.fecha_fin))) ) se_muestra = true 
 //    if(boutique.idcontrato!==null && boutiques_activas.contrato_finalizado){ if( fechaPaso(new Date(),new Date(boutique.idcontrato.fecha_inicio),new Date(boutique.idcontrato.fecha_fin)) ) se_muestra = true }
 //    if(boutiques_activas.sin_contrato && boutique.idcontrato===null) se_muestra = true 

 //    if(!boutiques_activas.contrato_activo && !boutiques_activas.contrato_finalizado && !boutiques_activas.sin_contrato) se_muestra = true

 //    return se_muestra

 // }




  const [ show_ModalAreasAtencionBoutique, setModalAreasAtencionBoutique ] = useState<boolean>(false)
  const handleShow_ModalAreasAtencionBoutique = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalAreasAtencionBoutique(true)
  }
  const handleClose_ModalAreasAtencionBoutique = () => {
            cargar()
    setModalAreasAtencionBoutique(false)
  }


  const width_svg = 30
  const height_svg = 30

  const width_svg_small = 20
  const height_svg_small = 20


  const [ ver_boutiques_sin_servicio, setBoutiquesSinServicio ] = useState<boolean>(false)





  const [ show_ModalBoutiquesPendientes, setModalBoutiquesPendientes ] = useState<boolean>(false)
  const handleShow_ModalBoutiquesPendientes = (boutique:any) => {
    setBoutiqueSeleccionada(boutique)
    setModalBoutiquesPendientes(true)
  }
  const handleClose_ModalBoutiquesPendientes = () => {
            cargar()
    setModalBoutiquesPendientes(false)
  }




      return (
          <>


      <div className="container-fluid">


      <div className="row justify-content-center">
        <div className="col-10 col-sm-11">


      <h3>Cliente</h3>

          <Row>
            <Col sm="2">
              

              { cliente.uuid && (<p className="text-center"><img className="mb-3" src={`${SERVER_}cliente/logotipo/${cliente.uuid}`} style={{width:'120px'}} /></p>)}



            </Col>
            <Col sm="3">

              <small><b>Cliente</b></small>

              <h4>{cliente.cliente}</h4>

              <small><b>Razón Social</b></small>
              <p className="nm">{cliente.razon_social}</p>


              <small><b>R.F.C.</b></small>
              <p className="nm">{cliente.rfc}</p>
            </Col>
            <Col sm="7">

              <Row>
                <Col sm="3" md="3">
                  <small><b>Teléfono</b></small>
                  <p className="nm">{cliente.telefono}</p>
                </Col>
                <Col sm="3" md="3">
                  <small><b>Email</b></small>
                  <p style={{overflowWrap:'break-word'}} className="nm">{cliente.email}</p>
                </Col>
                <Col sm="3" md="3">
                  <small><b>Contacto</b></small>
                  <p className="nm">{cliente.nombre_contacto}</p>
                </Col>
                <Col sm="3" md="3">
                  <small><b>Celular Contacto</b></small>
                  <p className="nm">{cliente.telefono_contacto}</p>
                </Col>
              </Row>



              <small><b>Dirección</b></small>
              <p className="nm">{cliente.direccion}</p>


              <Row>
                <Col sm="4" md="4">
                  <small><b>C.P.</b></small>
                  <p className="nm">{cliente.cp}</p>
                </Col>
                <Col sm="4" md="4">
                  <small><b>Estado</b></small>
                  <p className="nm">{cliente.idestado.estado}</p>
                </Col>
                <Col sm="4" md="4">
                  <small><b>Municipio</b></small>
                  <p className="nm">{cliente.idmunicipio.municipio}</p>
                </Col>
              </Row>

            </Col>

          </Row>






          <Row>
            <Col sm="6">
                  
                  <p className="nm"><small>Opciones</small></p>

                  <ul className="list-inline mt-2">
                    <li className="list-inline-item">
                      <button className="btn btn-link btn-sm" onClick={handleShow_ModalEditarDatosCliente}>
                        Editar Información               
                      </button>
                    </li>
                    <li className="list-inline-item">
                      <button className="btn btn-link btn-sm" onClick={handleShow_ModalClienteUsuarios}>
                        Usuarios
                      </button>
                    </li>
                  {
                    // <li className="list-inline-item">
                    //   <button onClick={handleShow_ModalContratosCliente} className="btn btn-link btn-sm">
                    //     Contratos
                    //   </button>
                    // </li>
                  }
                      {
                        // cliente.boutiques.length > 0 && (
                          <li className="list-inline-item">
                            <button onClick={handleShow_ModalAgregarBoutique} type="button" className="btn btn-link btn-sm">Añadir Boutique</button>
                          </li>
                        // )
                      }
                  </ul>

            </Col>
            <Col sm="6">
                  <p className="nm"><small>Filtro</small></p>
                  <Form.Check checked={ver_boutiques_sin_servicio} onChange={(e:any)=>{cargarBoutiques(e.target.checked)}} onClick={(e:any)=>{setBoutiquesSinServicio(e.target.checked)}} type={'checkbox'} id={`default-iflt`} label={`Ver Boutiques sin servicios`} />
            </Col>
            <Col>

                  {
                    // JSON.stringify(boutiques_activas)
                  }
{

                  // <p className="nm"><small>Filtros</small></p>
                  // <div className="mt-2">
                  //   <div className="form-check form-check-inline">
                  //     <input className="form-check-input" type="checkbox" id="Activo" checked={boutiques_activas.contrato_activo} onChange={(e:any)=>{setBoutiquesActivas({...boutiques_activas, contrato_activo : e.target.checked })}} />
                  //     <label className="form-check-label" htmlFor="Activo">Contrato Activo</label>
                  //   </div>
                  //   <div className="form-check form-check-inline">
                  //     <input className="form-check-input" type="checkbox" id="Concluido" checked={boutiques_activas.contrato_finalizado} onChange={(e:any)=>{setBoutiquesActivas({...boutiques_activas, contrato_finalizado : e.target.checked })}} />
                  //     <label className="form-check-label" htmlFor="Concluido">Contrato Concluido</label>
                  //   </div>
                  //   <div className="form-check form-check-inline">
                  //     <input className="form-check-input" type="checkbox" id="SinContrato" checked={boutiques_activas.sin_contrato} onChange={(e:any)=>{setBoutiquesActivas({...boutiques_activas, sin_contrato : e.target.checked })}} />
                  //     <label className="form-check-label" htmlFor="SinContrato">Sin Contrato</label>
                  //   </div>
                  // </div>
                }

            </Col>
          </Row>










                  {
                    cliente.boutiques.length > 0 && (

                        <>






                          <div className="table-responsive">

                            <table className="table">
                              <thead>
                                <tr>
                                  <th scope="col">Boutique</th>
                                        <th scope="col">
                                          <svg height="30" width="30" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  > <path style={{fill:'#E6E6E6'}} d="M8.788,93.889v324.225c0,14.811,12.011,26.822,26.821,26.822h440.78 c14.811,0,26.822-12.01,26.822-26.822V93.889c0-14.823-12.01-26.822-26.822-26.822H35.61C20.799,67.067,8.788,79.065,8.788,93.889z" /> <circle style={{fill:'#4D4D4D'}} cx="323.967" cy="255.993" r="147.676"/> <g> <path style={{fill:'#247396'}} d="M205.526,254.349c0,34.567,35.563,57.709,67.165,43.695l31.11-13.78 c-8.812-6.292-14.565-16.604-14.565-28.263c0-0.551,0.012-1.101,0.047-1.652H205.526z"/> <path style={{fill:'#247396'}} d="M322.327,290.673v83.769c34.555,0,57.697-35.574,43.695-67.177l-13.78-31.122 c-6.292,8.823-16.616,14.577-28.286,14.577C323.405,290.72,322.866,290.709,322.327,290.673z"/> <path style={{fill:'#247396'}} d="M344.11,227.727c8.823,6.281,14.577,16.604,14.577,28.274c0,0.551-0.012,1.101-0.047,1.64h0.012 h83.757c0-34.567-35.563-57.709-67.165-43.707l-31.122,13.78L344.11,227.727z"/> <path style={{fill:'#247396'}} d="M325.608,221.317v-83.769c-34.555,0-57.697,35.563-43.695,67.165l13.78,31.122 c6.292-8.823,16.604-14.565,28.263-14.565C324.506,221.27,325.057,221.282,325.608,221.317z"/> <path style={{fill:'#247396'}} d="M325.608,221.317c-0.551-0.035-1.101-0.047-1.652-0.047c-11.659,0-21.97,5.742-28.263,14.565 c-3.773,5.261-6.093,11.636-6.409,18.514c-0.035,0.551-0.047,1.101-0.047,1.652c0,11.659,5.753,21.97,14.565,28.263h0.012 c5.261,3.773,11.624,6.105,18.514,6.41c0.539,0.035,1.078,0.047,1.629,0.047c11.671,0,21.994-5.753,28.286-14.577 c3.761-5.261,6.081-11.624,6.398-18.502c0.035-0.539,0.047-1.09,0.047-1.64c0-11.671-5.753-21.994-14.577-28.274 C338.848,223.954,332.486,221.634,325.608,221.317z"/> </g> <path d="M233.053,383.365c26.631,19.04,58.066,29.104,90.908,29.104c86.278,0,156.469-70.192,156.469-156.469 S410.238,99.53,323.961,99.53s-156.469,70.192-156.469,156.469c0,38.512,14.117,75.522,39.753,104.214 c3.233,3.618,8.788,3.932,12.409,0.698c3.62-3.234,3.931-8.789,0.698-12.409C197.6,323.037,185.069,290.185,185.069,256 c0-76.586,62.307-138.893,138.893-138.893S462.855,179.414,462.855,256s-62.309,138.893-138.894,138.893 c-29.154,0-57.054-8.93-80.686-25.826c-3.948-2.823-9.436-1.91-12.26,2.038C228.192,375.053,229.104,380.541,233.053,383.365z"/> <path d="M8.788,347.672c4.853,0,8.788-3.935,8.788-8.788v-245c0-9.944,8.089-18.032,18.032-18.032h381.854 c4.853,0,8.788-3.935,8.788-8.788c0-4.853-3.935-8.788-8.788-8.788H35.608C15.973,58.276,0,74.249,0,93.884v245 C0,343.738,3.935,347.672,8.788,347.672z"/> <path d="M476.392,58.276H447.93c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h28.462 c9.944,0,18.032,8.089,18.032,18.032v324.232c0,9.944-8.089,18.032-18.032,18.032H35.608c-9.944,0-18.032-8.089-18.032-18.032 v-49.938c0-4.853-3.935-8.788-8.788-8.788S0,363.325,0,368.178v49.938c0,19.635,15.973,35.608,35.608,35.608h440.783 c19.635,0,35.609-15.973,35.609-35.608V93.884C512,74.249,496.027,58.276,476.392,58.276z"/> <path d="M205.525,245.561c-4.853,0-8.788,3.935-8.788,8.788c0,19.221,9.619,36.955,25.732,47.435 c9.353,6.084,20.052,9.177,30.82,9.176c7.779,0,15.594-1.614,22.961-4.882l26.884-11.909c3.287,1.802,6.777,3.166,10.404,4.058 v76.213c0,4.853,3.935,8.788,8.788,8.788c19.211,0,36.937-9.618,47.419-25.727c10.485-16.114,12.097-36.226,4.312-53.795 l-11.907-26.894c1.792-3.279,3.145-6.763,4.036-10.384h76.223c4.853,0,8.788-3.935,8.788-8.788c0-19.219-9.618-36.951-25.728-47.434 c-16.11-10.483-36.217-12.093-53.782-4.309l-26.906,11.913c-3.277-1.794-6.762-3.15-10.384-4.04v-76.224 c0-4.853-3.935-8.788-8.788-8.788c-19.212,0-36.94,9.617-47.421,25.725c-10.483,16.11-12.093,36.219-4.309,53.787l11.905,26.888 c-1.796,3.282-3.154,6.773-4.046,10.401h-76.21V245.561z M269.128,290.01c-12.109,5.37-25.97,4.264-37.074-2.96 c-8.595-5.592-14.511-14.176-16.747-23.913h65.75c1.104,6.597,3.72,12.831,7.593,18.227L269.128,290.01z M355.013,347.917 c-5.59,8.592-14.169,14.505-23.899,16.742v-65.761c6.599-1.106,12.834-3.724,18.228-7.595l8.644,19.523 C363.355,322.94,362.243,336.806,355.013,347.917z M378.803,221.969c12.111-5.367,25.973-4.256,37.079,2.97 c8.595,5.592,14.509,14.177,16.746,23.913h-65.76c-1.105-6.606-3.723-12.844-7.594-18.236L378.803,221.969z M349.898,256.001 c0,0.36-0.006,0.721-0.028,1.072c-0.003,0.055-0.006,0.11-0.009,0.164c-0.228,4.982-1.878,9.753-4.774,13.803 c-4.864,6.82-12.764,10.891-21.131,10.891c-0.359,0-0.71-0.006-1.06-0.028c-0.06-0.004-0.12-0.007-0.179-0.009 c-4.969-0.22-9.735-1.87-13.78-4.771c-0.089-0.063-0.178-0.125-0.268-0.185c-6.67-4.879-10.642-12.682-10.642-20.936 c0-0.366,0.006-0.731,0.028-1.097c0.004-0.05,0.006-0.101,0.008-0.152c0.23-4.993,1.88-9.763,4.785-13.815 c4.858-6.811,12.749-10.88,21.108-10.88c0.362,0,0.724,0.005,1.086,0.028c0.054,0.004,0.108,0.006,0.162,0.009 c4.985,0.229,9.751,1.88,13.809,4.789C345.829,239.737,349.898,247.631,349.898,256.001z M292.918,164.071 c5.59-8.592,14.17-14.504,23.9-16.741v65.759c-6.601,1.104-12.834,3.718-18.227,7.587l-8.644-19.523 C284.581,189.04,285.691,175.178,292.918,164.071z"/> <path d="M139.563,116.275H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,116.275,139.563,116.275z"/> <path d="M139.563,247.213H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,251.148,144.418,247.213,139.563,247.213z"/> <path d="M139.563,334.504H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,338.439,144.418,334.504,139.563,334.504z"/> <path d="M139.563,290.859H48.171c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h91.392 c4.853,0,8.788-3.935,8.788-8.788C148.351,294.793,144.418,290.859,139.563,290.859z"/> <path d="M139.563,378.15H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,378.15,139.563,378.15z"/> <path d="M139.563,203.567h-9.959c-4.853,0-8.788,3.935-8.788,8.788c0,4.853,3.935,8.788,8.788,8.788h9.959 c4.853,0,8.788-3.935,8.788-8.788C148.351,207.502,144.418,203.567,139.563,203.567z"/> <path d="M48.171,221.144h52.14c4.853,0,8.788-3.935,8.788-8.788c0-4.853-3.935-8.788-8.788-8.788h-52.14 c-4.853,0-8.788,3.935-8.788,8.788C39.383,217.209,43.317,221.144,48.171,221.144z"/> <path d="M139.563,159.921H48.171c-4.853,0-8.788,3.935-8.788,8.788s3.935,8.788,8.788,8.788h91.392c4.853,0,8.788-3.935,8.788-8.788 S144.418,159.921,139.563,159.921z"/> </svg>
                                        </th>
                                        <th scope="col">
                                          <svg width="30" height="30" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg"  aria-hidden="true" role="img" > <linearGradient id="IconifyId17ecdb2904d178eab12250" gradientUnits="userSpaceOnUse" x1="50.005" y1="32.3" x2="50.005" y2="-3.131" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset=".003" stopColor="#303f9f"> </stop> <stop offset=".472" stopColor="#273492"> </stop> <stop offset="1" stopColor="#1a237e"> </stop> </linearGradient> <path d="M96 120.76v3.2H4v-3.2c0-7.94 4.68-13.79 11.87-17.82c8.9-5 21.65-7.22 34.13-7.24s25.15 2.49 34.02 7.54c7.27 4.13 11.98 9.97 11.98 17.52z" fill="url(#IconifyId17ecdb2904d178eab12250)"> </path> <path d="M50 92.33h-9.08v9.98c0 4.51 3.7 8.17 8.26 8.17h1.65c4.56 0 8.26-3.66 8.26-8.17v-9.98H50z" fill="#99674f"> </path> <path d="M104.2 104.61l-4.04 19.35h15.08v-3.2c.01-6.75-4.26-12.14-11.04-16.15z" fill="#1b2b8f"> </path> <path fill="#f5f5f5" d="M59.31 104.52h-19.9l7.9 19.44h5.04z"> </path> <linearGradient id="IconifyId17ecdb2904d178eab12251" gradientUnits="userSpaceOnUse" x1="30.641" y1="28.749" x2="41.245" y2="2.796" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#5c6bc0"> </stop> <stop offset="1" stopColor="#3949ab"> </stop> </linearGradient> <path fill="url(#IconifyId17ecdb2904d178eab12251)" d="M40.88 95.93l-7.78.9l-8 17.25l10.88-4.29l9.55 14.17H48.25z"> </path> <linearGradient id="IconifyId17ecdb2904d178eab12252" gradientUnits="userSpaceOnUse" x1="69.02" y1="29.973" x2="61.206" y2="2.763" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#5c6bc0"> </stop> <stop offset="1" stopColor="#3949ab"> </stop> </linearGradient> <path fill="url(#IconifyId17ecdb2904d178eab12252)" d="M66.91 96.83l-7.79-.9l-7.36 28.03h3l10.05-14l10.1 4.12z"> </path> <linearGradient id="IconifyId17ecdb2904d178eab12253" gradientUnits="userSpaceOnUse" x1="110.125" y1="75.487" x2="98.869" y2="4.975" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#90a4ae"> </stop> <stop offset=".267" stopColor="#889da8"> </stop> <stop offset=".584" stopColor="#78909c"> </stop> <stop offset="1" stopColor="#607d8b"> </stop> </linearGradient> <path d="M121.82 56.71c-.34-.6-.92-.88-1.49-.88c-.76 0-1.5.49-1.67 1.38l-1.46 7.9c-.1.53-.44.99-.93 1.22l-8.08 3.87a1.673 1.673 0 0 1-1.96-.36l-6.16-6.5c-.37-.39-.53-.94-.44-1.47l1.46-7.9c.21-1.14-.69-2-1.68-2c-.37 0-.75.12-1.09.4c-2.95 2.45-5.12 5.97-5.89 10.12c-1.09 5.9.91 11.61 4.82 15.33c1.76 1.68 2.6 4.1 2.16 6.49l-7.33 39.66h10.32l6.99-37.82c.44-2.39 2.09-4.35 4.33-5.29c4.98-2.08 8.89-6.69 9.98-12.6c.77-4.15 0-8.22-1.88-11.55z" fill="url(#IconifyId17ecdb2904d178eab12253)"> </path> <g> <linearGradient id="IconifyId17ecdb2904d178eab12254" gradientUnits="userSpaceOnUse" x1="86.712" y1="20.544" x2="111.895" y2="20.544" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#a47b62"> </stop> <stop offset=".5" stopColor="#ba8d68"> </stop> </linearGradient> <path d="M94.5 117.31l-1.9 2.15s-5.68-1.21-5.01-4.5c.16-.78 1.56-2.44 1.56-2.44s-2.85-2.35-2.4-3.94c.45-1.57 3.17-2.79 3.17-2.79s-2.11-1.26-1.28-3.63c.57-1.62 3.53-2.16 3.53-2.16s-2.76-4.05 2.85-4.97c1.77-.29 5.74.3 9.3 2.93s5.19 4.21 6.83 7.67c2.5 5.25-1.92 14.25-5.31 14.33c-2.82.06-11.34-2.65-11.34-2.65z" fill="url(#IconifyId17ecdb2904d178eab12254)"> </path> </g> <g> <path d="M77.27 50.23H22.61c-5.89 0-10.71 5.13-10.71 11.41s4.82 11.41 10.71 11.41h54.66c5.89 0 10.71-5.14 10.71-11.41s-4.82-11.41-10.71-11.41z" fill="#99674f"> </path> <path d="M49.94 10.86c-17.4 0-33.52 18.61-33.52 45.4c0 26.64 16.61 39.81 33.52 39.81S83.46 82.9 83.46 56.26c0-26.79-16.12-45.4-33.52-45.4z" fill="#ba8d68"> </path> <g fill="#49362e"> <ellipse cx="34.13" cy="58.6" rx="4.93" ry="5.1"> </ellipse> <ellipse cx="65.28" cy="58.6" rx="4.93" ry="5.1"> </ellipse> </g> <g fill="#613e31"> <path d="M25.93 50.52s.13-.19.38-.51c.07-.08.12-.16.22-.26c.11-.11.23-.22.36-.33c.14-.12.28-.24.43-.38c.15-.13.31-.22.48-.35c.17-.12.34-.24.53-.35c.19-.1.4-.21.6-.32c.21-.12.43-.21.66-.3c.23-.09.47-.18.71-.27c.49-.14 1-.29 1.54-.36c.53-.1 1.08-.11 1.62-.14c.55.03 1.1.03 1.62.14c.53.06 1.05.22 1.54.36c.24.08.48.17.71.27c.23.09.45.18.66.3c.21.11.41.22.6.32c.19.11.37.24.53.35c.17.12.33.22.47.34c.14.12.27.24.4.35c.12.11.24.21.34.31c.1.1.18.21.26.29c.31.36.46.58.46.58c.51.7.35 1.69-.36 2.19c-.43.31-.96.37-1.43.21l-.29-.1s-.19-.07-.49-.2c-.08-.03-.15-.07-.25-.11c-.1-.03-.19-.07-.3-.11c-.21-.08-.44-.17-.7-.24c-.13-.04-.26-.09-.4-.13c-.14-.03-.28-.07-.43-.11l-.22-.06c-.08-.01-.15-.03-.23-.04c-.16-.03-.31-.07-.47-.1c-.33-.04-.66-.11-1-.12c-.34-.04-.69-.03-1.03-.05c-.35.02-.69.01-1.03.05c-.34.02-.67.09-1 .12c-.16.03-.32.07-.47.1c-.08.01-.16.03-.23.04l-.22.06c-.15.04-.29.07-.43.11c-.14.04-.27.09-.4.13c-.13.04-.25.08-.37.11c-.1.04-.2.07-.29.1l-.27.09c-.1.04-.2.1-.29.14c-.36.18-.57.27-.57.27c-.83.34-1.77-.05-2.11-.87c-.21-.51-.13-1.08.16-1.52z"> </path> <path d="M71.99 52.92s-.21-.09-.57-.27c-.09-.04-.19-.1-.29-.14c-.09-.02-.18-.06-.27-.09c-.09-.03-.19-.07-.29-.1c-.12-.04-.24-.07-.37-.11c-.13-.04-.26-.09-.39-.13c-.14-.03-.28-.07-.43-.11l-.22-.06c-.08-.01-.15-.03-.23-.04c-.16-.03-.31-.07-.47-.1c-.33-.04-.66-.11-1-.12c-.34-.04-.69-.03-1.03-.05c-.35.02-.69.01-1.03.05c-.34.02-.67.09-1 .12c-.16.03-.32.07-.47.1c-.08.01-.16.03-.23.04l-.22.06c-.15.04-.29.08-.43.11c-.14.04-.27.09-.4.13c-.26.07-.49.16-.7.24c-.1.04-.2.08-.3.11c-.09.04-.17.08-.25.11c-.3.13-.49.2-.49.2l-.28.1c-.82.29-1.72-.15-2-.97c-.17-.5-.08-1.03.21-1.44c0 0 .15-.22.46-.58c.08-.09.16-.19.26-.29c.1-.1.22-.2.34-.31c.12-.11.26-.23.4-.35c.14-.12.31-.22.47-.34c.17-.12.34-.24.53-.35c.19-.1.4-.21.6-.32c.21-.12.43-.21.66-.3c.23-.09.47-.18.71-.27c.49-.14 1-.29 1.54-.36c.53-.1 1.08-.11 1.62-.14c.55.03 1.1.03 1.62.14c.54.06 1.05.22 1.54.36c.24.08.48.17.71.27c.23.09.45.18.66.3c.21.11.41.22.6.32c.19.11.36.24.53.35c.17.12.32.22.48.35c.15.13.3.26.43.38s.26.23.36.33c.09.1.15.18.22.26c.25.31.38.51.38.51c.5.74.31 1.74-.43 2.25c-.47.31-1.05.35-1.54.15z"> </path> </g> <path d="M53.8 67.85c-.11-.04-.21-.07-.32-.08H46.4c-.11.01-.22.04-.32.08c-.64.26-.99.92-.69 1.63c.3.71 1.71 2.69 4.55 2.69s4.25-1.99 4.55-2.69c.3-.7-.05-1.37-.69-1.63z" fill="#99674f"> </path> <path d="M58.47 75.94c-3.19 1.89-13.63 1.89-16.81 0c-1.83-1.09-3.7.58-2.94 2.24c.75 1.63 6.44 5.42 11.37 5.42s10.55-3.79 11.3-5.42c.75-1.67-1.09-3.33-2.92-2.24z" fill="#5d4037"> </path> </g> <g> <path d="M49.96 4.55h-.04c-45.43.24-36.13 52.14-36.13 52.14s2.04 5.35 2.97 7.71c.13.34.63.3.71-.05c.97-4.34 4.46-19.73 6.22-24.4a6.08 6.08 0 0 1 6.8-3.83c4.45.81 11.55 1.81 19.37 1.81h.16c7.83 0 14.92-1 19.37-1.81c2.9-.53 5.76 1.08 6.79 3.83c1.75 4.66 5.22 19.96 6.2 24.36c.08.36.58.39.71.05l2.98-7.67c.02 0 9.33-51.9-36.11-52.14z" fill="#543930"> </path> <radialGradient id="IconifyId17ecdb2904d178eab12255" cx="49.941" cy="80.383" r="38.093" gradientTransform="matrix(1 0 0 -1.1282 0 138.304)" gradientUnits="userSpaceOnUse"> <stop offset=".794" stopColor="#6d4c41" stopOpacity={0}> </stop> <stop offset="1" stopColor="#6d4c41"> </stop> </radialGradient> <path d="M86.09 56.69S95.4 4.79 49.96 4.55h-.04c-.71 0-1.4.02-2.08.05c-1.35.06-2.66.16-3.92.31h-.04c-.09.01-.17.03-.26.04C5.38 9.76 13.79 56.69 13.79 56.69l2.98 7.68c.13.34.62.31.7-.05c.98-4.39 4.46-19.71 6.22-24.37a6.08 6.08 0 0 1 6.8-3.83c4.45.81 11.55 1.81 19.37 1.81h.16c7.83 0 14.92-1 19.37-1.81c2.9-.53 5.76 1.08 6.79 3.83c1.76 4.68 5.25 20.1 6.21 24.42c.08.36.57.39.7.05c.95-2.36 3-7.73 3-7.73z" fill="url(#IconifyId17ecdb2904d178eab12255)"> </path> </g> <g> <linearGradient id="IconifyId17ecdb2904d178eab12256" gradientUnits="userSpaceOnUse" x1="49.996" y1="89.161" x2="49.996" y2="129.378" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#0068b5"> </stop> <stop offset=".807" stopColor="#4c8eea"> </stop> <stop offset="1" stopColor="#5e97f6"> </stop> </linearGradient> <path d="M49.73 4.55c22.8 0 36.44 13.09 37.27 40.22c0 0-9.75-8.02-36.77-8.02c-29.25 0-37.26 8.54-37.23 7.6c1.03-27.27 14.29-39.8 37.23-39.8h-.5z" fill="url(#IconifyId17ecdb2904d178eab12256)"> </path> <linearGradient id="IconifyId17ecdb2904d178eab12257" gradientUnits="userSpaceOnUse" x1="49.725" y1="82.577" x2="49.725" y2="108.333" gradientTransform="matrix(1 0 0 -1 0 128)"> <stop offset="0" stopColor="#0068b5"> </stop> <stop offset="1" stopColor="#5e97f6"> </stop> </linearGradient> <path d="M26.93 34.41c0-18.74 8.97-28.81 22.8-28.81s22.8 10.47 22.8 28.81c0 14.9-10.78 3.17-22.8 3.17s-22.8 11.74-22.8-3.17z" fill="url(#IconifyId17ecdb2904d178eab12257)"> </path> <path d="M50.08 28.44c-21.77 0-32.21 11.89-32.21 11.89c-.02 1.97 2.2 5.52 7.25 6.33c6.95 1.12 11.44-4.5 24.85-4.5h.07v-.03l.04.03h.07c13.41 0 17.89 5.61 24.85 4.5c5.05-.81 6.89-3.85 6.87-5.81c0 0-9.76-12.41-31.79-12.41z" fill="#5e97f6"> </path> </g> </svg>
                                        </th>
                                        <th scope="col">
                                          <svg height="30" width="30" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" > <path style={{fill:'#AF7AAE'}} d="M460.8,439.242H158.989l-21.558-247.916h344.926L460.8,439.242z"/> <path style={{fill:'#8E5B8E'}} d="M482.358,169.768v21.558l-1.874,21.558H139.306l-1.874-21.558v-21.558H482.358z"/> <path style={{fill:'#D199D1'}} d="M503.916,148.211v21.558c0,11.906-9.651,21.558-21.558,21.558H137.432 c-11.906,0-21.558-9.651-21.558-21.558v-21.558c0-11.906,9.651-21.558,21.558-21.558h344.926 C494.264,126.653,503.916,136.304,503.916,148.211z"/> <path style={{fill:'#A7E5CB'}} d="M471.579,428.463L471.579,428.463c0,17.859-14.477,32.337-32.337,32.337h-66.521 c1.192,3.372,1.847,6.999,1.847,10.779l0,0c0,17.859-14.477,32.337-32.337,32.337H40.421c-17.86,0-32.337-14.478-32.337-32.337l0,0 c0-17.859,14.477-32.337,32.337-32.337h66.521c-1.192-3.372-1.848-6.999-1.848-10.779l0,0c0-17.859,14.477-32.337,32.337-32.337 h301.811C457.102,396.126,471.579,410.605,471.579,428.463z M383.222,158.886c4.731,0.46,9.165-0.638,12.905-2.804v45.507 c0,11.69,9.09,21.645,20.772,22.06c12.264,0.437,22.344-9.377,22.344-21.544v-75.453c0-5.953-4.826-10.779-10.779-10.779h-21.558 h-10.779h-21.558c-5.953,0-10.779,4.826-10.779,10.779v10.289C363.789,148.116,372.1,157.804,383.222,158.886z"/> <path style={{fill:'#D7F3FF'}} d="M180.547,428.463c0,5.953-4.826,10.779-10.779,10.779h-32.337c-5.953,0-10.779-4.826-10.779-10.779 s4.826-10.779,10.779-10.779h32.337C175.722,417.684,180.547,422.51,180.547,428.463z M126.653,460.8H40.421 c-5.953,0-10.779,4.826-10.779,10.779s4.826,10.779,10.779,10.779h86.232c5.953,0,10.779-4.826,10.779-10.779 S132.606,460.8,126.653,460.8z"/> <path style={{fill:'#A89B80'}} d="M353.01,374.568h64.674c47.625,0,86.232,38.607,86.232,86.232v32.337 c0,5.953-4.826,10.779-10.779,10.779h-204.8c-47.625,0-86.232-38.607-86.232-86.232v-75.453c0-11.906,9.651-21.558,21.558-21.558 h86.232c11.906,0,21.558,9.651,21.558,21.558v10.779C331.453,364.917,341.104,374.568,353.01,374.568z"/> <path style={{fill:'#C1B291'}} d="M503.916,460.8v43.116H331.453c-47.625,0-86.232-38.607-86.232-86.232v-75.453 c0-11.906,9.651-21.558,21.558-21.558h43.116c11.906,0,21.558,9.651,21.558,21.558v10.779c0,11.906,9.651,21.558,21.558,21.558 h43.116h21.558C465.309,374.568,503.916,413.175,503.916,460.8z"/> <path style={{fill:'#A89B80'}} d="M503.916,460.8v43.116H374.568c-47.625,0-86.232-38.607-86.232-86.232v-43.116 c0,47.625,38.607,86.232,86.232,86.232H503.916z"/> <path style={{fill:'#DBCBA1'}} d="M492.351,417.684H374.568c-47.625,0-86.232-38.607-86.232-86.232v-10.779h21.558 c11.906,0,21.558,9.651,21.558,21.558v10.779c0,11.906,9.651,21.558,21.558,21.558h64.674 C449.596,374.568,477.439,391.917,492.351,417.684z"/> <path style={{fill:'#91F18B'}} d="M288.337,29.642v237.137v21.558h-43.116v-21.558V29.642c0-11.906,9.651-21.558,21.558-21.558 C278.685,8.084,288.337,17.736,288.337,29.642z"/> <path style={{fill:'#6BAF6E'}} d="M266.779,29.642v258.695h-21.558V29.642c0-11.906,9.651-21.558,21.558-21.558 c3.931,0,7.606,1.069,10.779,2.907C271.121,14.721,266.779,21.668,266.779,29.642z"/> <path style={{fill:'#FFC248'}} d="M342.232,309.895L342.232,309.895c0,11.906-9.651,21.558-21.558,21.558H212.884 c-11.906,0-21.558-9.651-21.558-21.558l0,0c0-11.906,9.651-21.558,21.558-21.558h21.558v-10.779c0-5.953,4.826-10.779,10.779-10.779 h43.116c5.953,0,10.779,4.826,10.779,10.779v10.779h21.558C332.58,288.337,342.232,297.988,342.232,309.895z"/> <path style={{fill:'#FFFF63'}} d="M342.232,309.895H191.326l0,0c0-11.906,9.651-21.558,21.558-21.558h107.789 C332.58,288.337,342.232,297.988,342.232,309.895L342.232,309.895z"/> <path d="M220.968,503.916c0,4.466-3.62,8.084-8.084,8.084H40.421C18.132,512,0,493.868,0,471.579 c0-22.289,18.132-40.421,40.421-40.421h54.271c0.61,0,1.137-0.219,1.568-0.651c0.282-0.284,0.755-0.907,0.751-1.903v-0.141 c0-22.289,18.132-40.421,40.421-40.421h32.337c4.465,0,8.084,3.618,8.084,8.084c0,4.466-3.62,8.084-8.084,8.084h-32.337 c-13.373,0-24.253,10.88-24.253,24.253v0.113c0.018,5.039-1.924,9.787-5.467,13.343c-3.474,3.486-8.098,5.407-13.021,5.407H40.421 c-13.373,0-24.253,10.88-24.253,24.253s10.879,24.253,24.253,24.253h172.463C217.349,495.832,220.968,499.45,220.968,503.916z M363.789,199.411c4.465,0,8.084-3.618,8.084-8.084s-3.62-8.084-8.084-8.084h-43.116c-4.465,0-8.084,3.618-8.084,8.084 s3.62,8.084,8.084,8.084H363.789z M499.548,413.998C507.467,427.798,512,443.78,512,460.8v32.337 c0,10.401-8.463,18.863-18.863,18.863h-204.8c-52.006,0-94.316-42.31-94.316-94.316v-75.453c0-2.895,0.424-5.763,1.246-8.511 c-7.291-5.406-12.025-14.073-12.025-23.826c0-16.344,13.297-29.642,29.642-29.642h13.474v-2.695c0-7.511,4.411-14.009,10.779-17.043 v-61.105H146.25l14.233,163.679c0.387,4.447-2.905,8.368-7.353,8.754c-4.452,0.406-8.368-2.904-8.755-7.353l-14.438-166.039 c-12.727-3.33-22.146-14.927-22.146-28.683v-21.558c0-16.344,13.297-29.642,29.642-29.642h99.705V29.642 C237.137,13.298,250.434,0,266.779,0s29.642,13.298,29.642,29.642v230.873c6.368,3.032,10.779,9.532,10.779,17.043v2.695h13.474 c16.345,0,29.642,13.298,29.642,29.642c0,9.753-4.734,18.42-12.025,23.826c0.822,2.749,1.246,5.617,1.246,8.511v10.779 c0,7.43,6.044,13.474,13.474,13.474h64.674c34.691,0,65.067,18.827,81.449,46.799C499.283,413.514,499.422,413.752,499.548,413.998z M253.305,258.695h26.947V29.642c0-7.43-6.044-13.474-13.474-13.474s-13.474,6.044-13.474,13.474V258.695z M237.137,183.242v-48.505 h-99.705c-7.43,0-13.474,6.044-13.474,13.474v21.558c0,7.409,6.011,13.44,13.412,13.474c0.051,0.001,0.103,0.001,0.155,0H237.137z M495.832,468.884H374.568c-15.993,0-31.796-4.078-45.699-11.793c-3.904-2.165-5.313-7.086-3.146-10.99 c2.167-3.903,7.086-5.315,10.991-3.147c11.511,6.388,24.601,9.764,37.856,9.764h120.848c-0.991-9.6-3.727-18.692-7.885-26.947 H374.568c-15.994,0-31.798-4.079-45.704-11.795c-3.904-2.167-5.313-7.087-3.146-10.99c2.165-3.905,7.087-5.312,10.991-3.146 c11.512,6.388,24.603,9.765,37.859,9.765h102.108c-14.339-16.498-35.469-26.947-58.992-26.947H353.01 c-16.345,0-29.642-13.298-29.642-29.642v-10.779c0-0.942-0.098-1.878-0.291-2.792c-0.793,0.065-1.595,0.097-2.404,0.097h-10.779 c-4.465,0-8.084-3.618-8.084-8.084s3.62-8.084,8.084-8.084h10.779c7.43,0,13.474-6.044,13.474-13.474s-6.044-13.474-13.474-13.474 h-21.558c-4.465,0-8.084-3.618-8.084-8.084V277.56c0-1.486-1.209-2.695-2.695-2.695h-43.116c-1.485,0-2.695,1.208-2.695,2.695 v10.779c0,4.466-3.62,8.084-8.084,8.084h-21.558c-7.43,0-13.474,6.044-13.474,13.474s6.044,13.474,13.474,13.474h64.674 c4.465,0,8.084,3.618,8.084,8.084s-3.62,8.084-8.084,8.084h-64.674c-0.808,0-1.611-0.032-2.404-0.097 c-0.192,0.914-0.291,1.85-0.291,2.792v75.453c0,39.461,29.402,72.186,67.447,77.418c-24.463-17.059-40.5-45.402-40.5-77.42v-53.895 c0-4.466,3.62-8.084,8.084-8.084c4.465,0,8.084,3.618,8.084,8.084v53.895c0,39.461,29.402,72.186,67.447,77.418 c-24.463-17.057-40.5-45.4-40.5-77.418v-53.895c0-4.466,3.62-8.084,8.084-8.084s8.084,3.618,8.084,8.084v53.895 c0,43.091,35.056,78.147,78.147,78.147h118.568c1.485,0,2.695-1.208,2.695-2.695V468.884z M512,148.211v21.558 c0,13.756-9.42,25.353-22.146,28.682l-14.438,166.04c-0.365,4.209-3.897,7.385-8.044,7.385c-0.235,0-0.472-0.01-0.71-0.03 c-4.447-0.386-7.74-4.306-7.353-8.754l14.233-163.68h-26.213v2.695c0,8.118-3.217,15.693-9.059,21.33 c-5.841,5.636-13.546,8.564-21.656,8.292c-16.021-0.57-28.57-13.809-28.57-30.139v-34.637c-1.85,0.169-3.723,0.164-5.602-0.019 c-15.243-1.484-26.735-14.378-26.735-29.991v-2.204h-35.032c-4.465,0-8.084-3.618-8.084-8.084c0-4.466,3.62-8.084,8.084-8.084 h36.853c3.032-6.367,9.532-10.779,17.042-10.779h53.895c7.51,0,14.009,4.412,17.042,10.779h36.853 C498.703,118.568,512,131.866,512,148.211z M431.158,126.653c0-1.486-1.209-2.695-2.695-2.695h-53.895 c-1.485,0-2.695,1.208-2.695,2.695v10.289c0,7.131,5.329,13.237,12.132,13.899c2.823,0.276,5.614-0.332,8.069-1.754 c1.253-0.725,2.652-1.089,4.051-1.089c1.394,0,2.787,0.36,4.038,1.08c2.504,1.444,4.046,4.113,4.046,7.004v45.507 c0,7.455,5.821,13.727,12.975,13.982c3.706,0.106,7.2-1.207,9.854-3.768c2.656-2.563,4.119-6.007,4.119-9.697v-75.454H431.158z M495.832,148.211c0-7.43-6.044-13.474-13.474-13.474h-35.032v48.505h34.938c0.053,0,0.103,0,0.155,0 c7.402-0.033,13.412-6.064,13.412-13.474V148.211z"/> </svg>
                                        </th>
                                  <th scope="col">Iguala</th>
                                  <th scope="col">Estado</th>
                                  <th scope="col">Municipio</th>
                                  <th scope="col">Zona</th>
                                  <th scope="col">Opción</th>
                                </tr>
                              </thead>
                              <tbody>
                              {
                                cliente.boutiques.map( (boutique:any, indice_boutique:number)=>
                                          <React.Fragment key={indice_boutique}>


                                            {
                                              // (( ver_boutiques_sin_servicio ) && ( boutique.servicio_mantenimiento || boutique.servicio_conservacion || boutique.servicio_limpieza ) ) && (
                                              true && (


                                            <tr  className={`${!boutique.idcontrato?'asignar_contrato-':''} 
                                            ${boutique.idcontrato && fechaPaso(new Date(),new Date(boutique.idcontrato.fecha_inicio),new Date(boutique.idcontrato.fecha_fin)) ? 'asignar_contrato' : ''}
                                            `}>
                                              <td className="v">
                                                <h6 className="nm">{boutique.nombre_boutique}</h6>
                                                <small>{boutique.acronimo_folio}</small>
                                              </td>


                                              {
                                                !boutique.activa && (
                                                  <td className="v" colSpan={3}>
                                                        <p className="nm text-center"><small><i className="fa fa-warning"/> Boutique inactiva</small></p>
                                                  </td>
                                                )
                                              }



                                              {
                                                boutique.activa && (
                                                  <>


                                                      <td className="v text-center" style={{width:70}}>
                                                          {boutique.servicio_mantenimiento?<i onClick={(e=>{handleShow_ModalEquiposCriticosBoutique(boutique)})} style={{color : ( boutique.idusuario_mantenimiento && boutique.equipos.length > 0 ? 'green' : '' ) }} className="pointer fa fa-check-circle"/>:''}
                                                      </td>
                                                      <td className="v text-center" style={{width:70}}>
                                                          {boutique.servicio_conservacion?<i onClick={(e=>{handleShow_ModalTareasConservacionBoutique(boutique)})} style={{color : ( boutique.idusuario_conservacion !== null && boutique.conservacion_instrucciones?.length > 0  ? 'green' : '' ) }}  className="pointer fa fa-check-circle"/>:''}
                                                      </td>
                                                      <td className="v text-center" style={{width:70}}>
                                                          {boutique.servicio_limpieza?<i onClick={(e=>{handleShow_ModalTareasLimpiezaBoutique(boutique)})} style={{color : ( boutique.idusuario_limpieza !== null && boutique.limpieza_instrucciones?.length > 0  ? 'green' : '' ) }}  className="pointer fa fa-check-circle"/>:''}

                                                          {
                                                            // JSON.stringify(boutique.idusuario_limpieza)
                                                          }
                                                          {
                                                            // boutique.idusuario_limpieza ? ' SI ' :'NO'
                                                          }
                                                      </td>


                                                      <td className="v text-center" style={{width:60}}>
                                                          {boutique.servicio_mantenimiento?<p style={{margin:0,fontSize:10,color:'blue'}}>$ {boutique.monto_iguala_mantenimiento}</p>:''}
                                                          {boutique.servicio_conservacion?<p style={{margin:0,fontSize:10,color:'orange'}}>$ {boutique.monto_iguala_conservacion}</p>:''}
                                                          {boutique.servicio_limpieza?<p style={{margin:0,fontSize:10,color:'green'}}>$ {boutique.monto_iguala_limpieza}</p>:''}
                                                      </td>



                                                  </>
                                                )
                                              }


                                              <td className="v" style={{width:240}}>
                                                <p className="nm"><small>{boutique.idestado.estado}</small></p>
                                              </td>
                                              <td className="v"  style={{width:240}}>
                                                <p className="nm"><small>{boutique.idmunicipio.municipio}</small></p>
                                              </td>
                                              <td className="v"  style={{width:180}}>
                                                <p className="nm"><b>{boutique.idsubarea.subarea}</b></p>
                                              </td>
                                              <td className="v text-left" style={{width:350}}>
                                              {
                                                <>
                                                { true && <Button onClick={(e:any)=>{handleShow_ModalEditarBoutique(boutique)}} className="pointer" size="sm" variant="light">
                                                  <img src={`../img/iconos/editar.png`} width={width_svg_small} height={height_svg_small} />
                                                </Button> }
                                                {' '}



                                                { 
                                                  boutique.activa && <Button onClick={(e:any)=>{handleShow_ModalBoutiquesUsuariosAcceso(boutique)}} className="pointer" size="sm" variant="light">
                                                    <img src={`../img/iconos/usuarios.png`} width={width_svg_small} height={height_svg_small} />
                                                  </Button> 
                                                }


                                                { 
                                                  boutique.activa && (
                                                    <>
                                                      <Button onClick={(e:any)=>{handleShow_ModalConfiguracionHorarios(boutique)}} className="pointer" size="sm" variant="light">
                                                        <img src={`../img/iconos/horario.png`} width={width_svg_small} height={height_svg_small} />
                                                      </Button>
                                                    </>
                                                    )
                                                }


                                                {' '}

                                                {' '}
                                                { 
                                                  boutique.activa && (
                                                    <>{
                                                        (boutique.servicio_mantenimiento || boutique.servicio_conservacion) && 
                                                        <Button onClick={(e:any)=>{handleShow_ModalClienteResponsableMantenimiento(boutique)}} className="pointer" size="sm" variant={ boutique.idresponsable_mantenimiento ? 'light' : 'primary' }>
                                                          <img src={`../img/iconos/responsable.png`} width={width_svg_small} height={height_svg_small} />  
                                                        </Button>
                                                      }
                                                    </>
                                                    )
                                                }
                                                 
                                                {' '}

                                                { 
                                                  boutique.activa && (
                                                    <>{
                                                        boutique.servicio_limpieza && 
                                                        <Button onClick={(e:any)=>{handleShow_ModalClienteResponsableLimpieza(boutique)}} className="pointer" size="sm" variant={ boutique.idresponsable_limpieza ? 'light' : 'primary' }>
                                                          <img src={`../img/iconos/jefe_limpieza.png`} width={width_svg_small} height={height_svg_small} />  
                                                        </Button>
                                                      }
                                                    </>
                                                    )
                                                }

                                                { 
                                                  boutique.activa && (
                                                    <>
                                                      <Button className="pointer" size="sm" variant="light" onClick={(e:any)=>{handleShow_ModalAreasAtencionBoutique(boutique)}}>
                                                       <img src={`../img/iconos/local.png`} width={width_svg_small} height={height_svg_small} />
                                                      </Button> 
                                                    </>
                                                    )
                                                }

                                                { 
                                                  boutique.activa && (
                                                    <>
                                                      <Button className="pointer" size="sm" variant="dark" onClick={(e:any)=>{handleShow_ModalBoutiquesPendientes(boutique)}}>
                                                       📑
                                                      </Button> 
                                                    </>
                                                    )
                                                }

                                                {' '}


                                                </>
                                              }
                                              </td>
                                            </tr> 



                                                )
                                            }
                                          </React.Fragment>
                                      )
                              }

                              </tbody>
                            </table>

                          </div>



                        </>

                    )
                  } 





          </div>
        </div>


      </div>





  {
    show_ModalClienteUsuarios && (
      <ModalClienteUsuarios show={show_ModalClienteUsuarios} handleClose={handleClose_ModalClienteUsuarios} cliente={cliente} />
      )

  }




  {
    show_ModalAgregarBoutique && (
      <ModalAgregarBoutique show={show_ModalAgregarBoutique} handleClose={handleClose_ModalAgregarBoutique} cliente={cliente} />
      )

  }


  {
    show_ModalEditarBoutique && (
      <ModalEditarBoutique show={show_ModalEditarBoutique} handleClose={handleClose_ModalEditarBoutique} boutique={boutique_seleccionada} />
      )

  }


  {
    show_ModalConfiguracionHorarios && (
      <ModalConfiguracionHorarios show={show_ModalConfiguracionHorarios} handleClose={handleClose_ModalConfiguracionHorarios} boutique={boutique_seleccionada}  />
      )

  }




  {
    show_ModalNuevoContratoCliente && (
      <ModalNuevoContratoCliente show={show_ModalNuevoContratoCliente} handleClose={handleClose_ModalNuevoContratoCliente} cliente={cliente} />
      )

  }


  {
    show_ModalEquiposCriticosBoutique && (
      <ModalEquiposCriticosBoutique show={show_ModalEquiposCriticosBoutique} handleClose={handleClose_ModalEquiposCriticosBoutique} boutique_={boutique_seleccionada}   />
      )

  }



  {
    show_ModalContratoSeleccionarBoutique && (
      <ModalContratoSeleccionarBoutique show={show_ModalContratoSeleccionarBoutique} handleClose={handleClose_ModalContratoSeleccionarBoutique} boutique={boutique_seleccionada}  />
      )

  }



  {
    show_ModalContratosCliente && (
      <ModalContratosCliente show={show_ModalContratosCliente} handleClose={handleClose_ModalContratosCliente} cliente={cliente}  />
      )

  }


  {
    show_ModalTareasLimpiezaBoutique && (
      <ModalTareasLimpiezaBoutique show={show_ModalTareasLimpiezaBoutique} handleClose={handleClose_ModalTareasLimpiezaBoutique} boutique_={boutique_seleccionada}  />
      )

  }

  {
    show_ModalEditarDatosCliente && (
      <ModalEditarDatosCliente show={show_ModalEditarDatosCliente} handleClose={handleClose_ModalEditarDatosCliente} cliente={cliente}   />
      )

  }


  {
    show_ModalTareasConservacionBoutique && (
      <ModalTareasConservacionBoutique show={show_ModalTareasConservacionBoutique} handleClose={handleClose_ModalTareasConservacionBoutique} boutique_={boutique_seleccionada} />
      )

  }


  {
    show_ModalClienteResponsableMantenimiento && (
      <ModalClienteResponsableMantenimiento show={show_ModalClienteResponsableMantenimiento} handleClose={handleClose_ModalClienteResponsableMantenimiento} boutique_={boutique_seleccionada}  />
      )

  }


  {
    show_ModalClienteResponsableLimpieza && (
      <ModalClienteResponsableLimpieza show={show_ModalClienteResponsableLimpieza} handleClose={handleClose_ModalClienteResponsableLimpieza} boutique_={boutique_seleccionada}  />
      )

  }




  {
    show_ModalBoutiquesUsuariosAcceso && (
      <ModalBoutiquesUsuariosAcceso show={show_ModalBoutiquesUsuariosAcceso} handleClose={handleClose_ModalBoutiquesUsuariosAcceso} boutique_={boutique_seleccionada} />
      )

  }





  {
    show_ModalAreasAtencionBoutique && (
      <ModalAreasAtencionBoutique show={show_ModalAreasAtencionBoutique} handleClose={handleClose_ModalAreasAtencionBoutique} boutique={boutique_seleccionada} />
      )

  }







  {
    show_ModalBoutiquesPendientes && (
      <ModalBoutiquesPendientes show={show_ModalBoutiquesPendientes} handleClose={handleClose_ModalBoutiquesPendientes}  boutique={boutique_seleccionada} />
      )

  }



          </>

      );
  

}

export default Cliente
